import { connect } from 'react-redux';

import { changePage, changePageParams } from 'actions';

import TeamPage from './TeamPage';

const mapStateToProps = state => ({
    batting: state.data.batting,
    bowling: state.data.bowling,
    fielding: state.data.fielding,
    fixtures: state.data.fixtures,
    leagueTable: state.data.leagueTable,
    record: state.data.record,
    team: state.data.team,
    season: state.data.params.season,
    pendingSeason: state.paramsPending && state.paramsPending.season
});

const mapDispatchToProps = dispatch => ({
    filterSeason: (field, season) => dispatch(changePageParams(field, season)),
    browserBack: (pathname, params) => dispatch(changePage(pathname, params))
});

const Team = connect(mapStateToProps, mapDispatchToProps)(TeamPage);

export default Team;



// WEBPACK FOOTER //
// ./src/views/team/index.js